import rpc from "@/rpc";

class InformationPartService {
    rpc

    constructor(rpc) {
        this.rpc = rpc
    }

    get(id) {
        return this.rpc.execute('getDeleteInformationPart', {
            id
        })
    }
}

export default new InformationPartService(rpc)